<template>
    <div class="filter-min-max">
        <div class="filter-label">
            <select class="form-control" v-model="value">
                <option value="">{{ t('reportFilters-select') }}</option>
                <option v-for="option in options" :value="option.value" :key="option.value">
                    {{ option.label }}
                </option>
            </select>
        </div>
    </div>
</template>
<style lang="scss" scoped>
select,
select:focus {
    background-color: transparent;
    border: transparent;
    outline: none;
    box-shadow: none;
    padding: 0 5px 0 0;
    margin: -7px 0;
}
</style>
<script>
export default {
    name: "selectbox",
    props: {
        options: {
            type: Array,
            default: () => [],
        },
        name: {
            type: String,
            default: "select",
        },
        currentValue: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            value: "",
        };
    },
    mounted() {
        if (this.currentValue) {
            this.value = this.currentValue;
        }
        if (this.value.length > 0) {
            this.changed();
        }
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        changed() {
            this.$emit("changed", this.value);
        },
    },
    watch: {
        value() {
            this.changed();
        },
    },
};
</script>
